import React from "react";
import { AiFillContacts, AiFillInfoCircle, AiFillSetting } from "react-icons/ai";
import { BsFacebook, BsGithub, BsPenFill } from "react-icons/bs";
import { FaHome, FaLinkedin } from "react-icons/fa";
import { TbCertificate } from "react-icons/tb";
import { Link, Outlet } from "react-router-dom";
import bannerImg from "../Assets/habibPic.jpg";
import Navbar from "../Components/Navbar/Navbar";
import './Main.css';
const Main = () => {

  return (
    <>
      <Navbar ></Navbar>
      <div className="drawer drawer-mobile">
        <input id="my-drawer-2" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content  bg-secondary">
          <Outlet></Outlet>
        </div>
        <div className="drawer-side">
          <label htmlFor="my-drawer-2" className="drawer-overlay"></label>
          <ul className="menu p-4 w-80  text-white bg-accent">
            <li>
              <div className="avatar">
                <div className="w-28 rounded-full ring ring-white">
                  <img src={bannerImg} alt="Habibullah" />
                </div>
              </div>

              <span className="text-xl font-bold">HABIBULLAH NOMANI</span>
            </li>

            <li className="text-xl">
              <Link to="/" className="menu-button">
                <FaHome />
                Home
              </Link>
            </li>
            <li className="text-xl " >
              <Link to="/about" className="menu-button">
                <AiFillInfoCircle />
                About Me
              </Link>
            </li>

            <li className="text-xl " >
              <Link to="/projects" className="menu-button">
                <AiFillSetting />
                Projects
              </Link>
            </li>

            <li className="text-xl">
              <Link to="/blog" className="menu-button">
                <BsPenFill />
                Blog
              </Link>
            </li>


            <li className="text-xl">
              <Link to="/certifications" className="menu-button">
                <TbCertificate />
                Certifications
              </Link>
            </li>

            <li className="text-xl">
              <Link to="/contact" className="menu-button">
                <AiFillContacts />
                Contact
              </Link>
            </li>

            <li>
              <span className=" text-primary">
                <a
                  href="https://github.com/Habibullah6"
                  target="blank"
                  className="text-xl inline-block mr-3"
                >
                  <BsGithub />
                </a>
                <a
                  href="https://www.linkedin.com/in/habibullah-nomani/"
                  target="blank"
                  className="text-xl inline-block mr-3"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="https://www.facebook.com/emma.mary.372661/"
                  target="blank"
                  className="text-xl inline-block"
                >
                  <BsFacebook />
                </a>
              </span>
            </li>



          </ul>
        </div>
      </div>
    </>
  );
};

export default Main;
